import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { User } from 'app/core/user/user.types';
import { environment } from 'environments/environment';
import { FuseConfigService } from '@fuse/services/config';
// import SecureLS from 'secure-ls';
// var ls = new SecureLS({encodingType: 'base64'});
import ls from 'localstorage-slim';
@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    private _userClient: ReplaySubject<any> = new ReplaySubject<any>(1);
    private _baseURL: string = environment.apiOrigin + '/apiv1/auth/user/'

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _fuseConfigService: FuseConfigService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value) {
        // Store the value
        console.log('value',value)
        ls.set('hms_loggedin_user', JSON.stringify(value));
        let theme = value.thme_nm; this._fuseConfigService.config = { theme };
        let layout = value.lyt_nm; this._fuseConfigService.config = { layout };
        this._user.next(value);

    }

    get user$(): Observable<User> {
        console.log(this._user,"pppppppppppppppppp")
        return this._user.asObservable();
    }
    /**
    * Setter & getter for user clients
    *
    * @param value
    */
    set userClients(value) {
        // Store the value
        console.log(value)
        ls.set('hms_loggedin_user_clients', JSON.stringify(value));
        this._userClient.next(value);
    }

    get userClients$(): Observable<User> {
        return this._userClient.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    get(): Observable<any> {
        return this._httpClient.get<any>(this._baseURL + 'profile').pipe(
            tap((res) => {
                console.log(res)
                if (res.status == 200 && res.data.length) {
                    this.user = res.data[0].user;
                    this.userClients = res.data[0].clnts;
                }
            })
        );
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any> {
        return this._httpClient.patch<User>('api/common/user', { user }).pipe(
            map((response) => {
                this._user.next(response);
            })
        );
    }
}
